import { Component, Input, OnInit } from '@angular/core';
import { ChartData, ChartType } from 'chart.js';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';

@Component({
    selector: 'app-bar-chart',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit {
    @Input() chartColors: string;
    @Input() chartData: number[];
    @Input() chartLabels: string[];
    barChartData: ChartData<'bar'>;
    barChartOptions;
    barChartType: ChartType = 'bar';
    barChartPlugins = [DataLabelsPlugin];
    barThickness: number = 25;
    divWidth;

    constructor() {}

    ngOnInit(): void {
        this.customChartOptions();
        this.setChartData();
        this.setDivWidthToAllowScroll();
    }

    setChartData() {
        this.barChartData = {
            labels: this.chartLabels.reverse(),
            datasets: [{ data: this.chartData.reverse(), backgroundColor: this.chartColors }]
        };
    }

    customChartOptions() {
        this.barChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            barThickness: this.barThickness,
            scales: {
                x: {
                    offset: true,
                    grid: { display: false, offset: true },
                    border: { color: '#f8f9fa' },
                    ticks: {
                        callback: function (value, index, ticks) {
                            const label = this.getLabelForValue(value);
                            return label.length > 10 ? label.slice(0, 10) + '...' : label;
                        },
                        font: { family: 'STCForward-Regular' }
                    }
                },
                y: {
                    offset: true,
                    display: false,
                    grid: { display: false, offset: true }
                }
            },
            plugins: {
                legend: { display: false },
                datalabels: {
                    anchor: 'end',
                    align: 'end',
                    color: this.chartColors,
                    textAlign: 'center'
                },
                tooltip: {
                    intersect: false,
                    mode: 'index',
                    backgroundColor: '#f8f9fa',
                    titleColor: '#1D252D',
                    titleAlign: 'center',
                    titleFont: { size: 16, family: 'STCForward-Regular' },
                    bodyColor: '#4f008c',
                    bodyAlign: 'center',
                    bodyFont: { size: 14, family: 'STCForward-Regular' },
                    displayColors: false,
                    padding: { top: 15, right: 20, left: 20, bottom: 10 }
                }
            },
            layout: {
                padding: {
                    top: 20 //for datalabel
                }
            }
        };
    }

    setDivWidthToAllowScroll() {
        this.divWidth = this.chartData.length > 10 ? this.chartData.length * 60 + 'px' : 'unset';
    }
}
